import React, { useState } from 'react'
import classNames from 'classnames'
import Snackbar from 'src/ui/atoms/Snackbar'

export interface IHiddenInfo {
  title: string
  info: string
}

const HiddenInfo = ({ title, info }: IHiddenInfo) => {
  const [showInfo, setShowInfo] = useState<boolean>(false)

  return (
    <div className="flex flex-col items-start justify-between gap-2 text-white">
      <div
        className="flex cursor-pointer flex-row items-center justify-start gap-1"
        onClick={() => setShowInfo((state) => !state)}>
        <span
          className={classNames('icon-arrow-right transition-rotate text-lg duration-200', {
            'rotate-0': !showInfo,
            'rotate-90': showInfo,
          })}
        />
        <span>{title}</span>
      </div>
      {showInfo && <Snackbar text={info} lineHeight="relaxed" />}
    </div>
  )
}

export default HiddenInfo
